<template>
  <div style="box-sizing: border-box; padding: 10px 20px 0; min-width: 1080px">
    <div class="section-right-content-box">
      <div class="router-title">会员列表</div>
      <div class="division-line"></div>
      <!-- 筛选部分 -->
      <div class="screen-box" style="text-align: left">
        <!-- 第一行表单 -->
        <div class="line">
          <el-form :inline="true" label-width="100px">
            <el-form-item label="买家账号:" style="color: #333">
              <el-input class="long-input" v-model="formDataList.pin" placeholder="请输入买家账号" size="small" style="width: 280px"></el-input>
            </el-form-item>
            <el-form-item label="买家姓名:">
              <el-input class="long-input" v-model="formDataList.fullName" placeholder="请输入买家姓名" style="width: 280px" size="small"></el-input>
            </el-form-item>
            <!-- <el-form-item label="手机号码:">
              <el-input
                class="long-input"
                v-model="formDataList.mobile"
                placeholder="请输入手机号码"
                style="width: 280px"
                size="small"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="最近交易时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataList.startBuyerLastTime"
                  type="datetime"
                  :picker-options="pickerOptionsStart"
                  :placeholder="'开始日期'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formDataList.endBuyerLastTime"
                  type="datetime"
                  :placeholder="'结束日期'"
                  :picker-options="pickerOptionsEnd"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item label="交易总额:">
              <el-input
                class="short-input"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                v-model="formDataList.startBuyTotalMoney"
                @keyup.native="formDataList.startBuyTotalMoney = oninput(formDataList.startBuyTotalMoney)"
                placeholder
                size="small"
                @change="startBuyTotalMoneystart"
                style="width: 120px"
              ></el-input>
              <span class="to-text">至</span>
              <el-input
                class="short-input"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                v-model="formDataList.endBuyTotalMoney"
                @keyup.native="formDataList.endBuyTotalMoney = oninput(formDataList.endBuyTotalMoney)"
                @change="startBuyTotalMoneyend"
                placeholder
                style="margin-right: -2px; width: 120px"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="购买次数:">
              <el-input
                class="short-input"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                v-model="formDataList.startBuyTotalCount"
                @change="changeTotalCountStart"
                @keyup.native="formDataList.startBuyTotalCount = oninput(formDataList.startBuyTotalCount)"
                placeholder
                size="small"
                style="width: 119px"
              ></el-input>
              <span class="to-text">至</span>
              <el-input
                class="short-input"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                v-model="formDataList.endBuyTotalCount"
                @change="changeTotalCountEnd"
                @keyup.native="formDataList.endBuyTotalCount = oninput(formDataList.endBuyTotalCount)"
                placeholder
                style="width: 119px"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="平均客单价:">
              <el-input
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                class="short-input"
                @change="changeTotalMoneyStart"
                @keyup.native="formDataList.startAvgPrice = oninput(formDataList.startAvgPrice)"
                v-model="formDataList.startAvgPrice"
                style="width: 120px"
                size="small"
              ></el-input>
              <span class="to-text">至</span>
              <el-input
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                class="short-input"
                @change="changeTotalMoneyEnd"
                @keyup.native="formDataList.endAvgPrice = oninput(formDataList.endAvgPrice)"
                v-model="formDataList.endAvgPrice"
                size="small"
                style="width: 120px"
              ></el-input>
            </el-form-item>

            <el-form-item label="指定SKU:">
              <inputSKU class="long-input" :sku.sync="formDataList.skuIds" size="small" style="width: 280px"></inputSKU>
            </el-form-item>
          </el-form>
          <el-form label-width="100px">
            <el-form-item label="选择标签:">
              <el-button size="small" class="button-status4" v-zoom="{ from: pageName, name: '选择标签' }" @click="toSearchLabel"
                >已选{{ selectSearchIds.length }}个
              </el-button>
            </el-form-item>
            <el-form-item label="会员等级:">
              <el-checkbox-group v-model="formDataList.grades" @change="initLevel" class="checked-box">
                <el-checkbox v-for="city in memberList" :label="city.value" :disabled="isInit" :key="city.value">
                  <span>{{ city.label }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="所在地区:" style="margin-top: -18px">
              <el-radio-group v-model="formDataList.province">
                <el-radio label @change="cityRadioChange('')">不限</el-radio>
                <el-tooltip content="江苏省、浙江省、上海" placement="bottom" effect="light">
                  <el-radio label="JZH" @change="cityRadioChange('JZH')">江浙沪</el-radio>
                </el-tooltip>
                <el-tooltip content="新疆、西藏、云南省、青海省" placement="bottom" effect="light">
                  <el-radio label="RemoteArea" @change="cityRadioChange('RemoteArea')">偏远地区</el-radio>
                </el-tooltip>
                <el-radio label="Customized" @click.stop.native="changeCityShow" @change="cityRadioChange('Customized')">自定义</el-radio>
                <el-button class="Customizedbutton" v-show="formDataList.province == 'Customized'" @click="cityRadioChange('Customized')">
                  已选择
                  <span>{{ formDataList.province == "Customized" ? checkedList.length : 0 }}</span>
                  个
                </el-button>
              </el-radio-group>
              <el-button
                slot="reference"
                size="small"
                class="button-status4"
                v-if="formDataList.province == '0'"
                :style="{ 'margin-left': '26px' }"
                @click="changeCityShow"
                >已选{{ checkedList.length }}个</el-button
              >

              <!-- <city-popover
                v-model="cityShow"
                :checkedList="checkedList"
                @on-change="(arr) => (checkedList = arr)"
              ></city-popover> -->
              <city-popover-x v-model="cityShow" @on-change="getLocation" :checkedList="checkedList"> </city-popover-x>
            </el-form-item>
          </el-form>
          <div class="line" style="text-align: center">
            <el-button icon="el-icon-search" class="button-status5" v-zoom="{ from: pageName, name: '查询' }" @click="seacherResult">查询</el-button>

            <el-button class="button-status2" @click="resetList">重置</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格数据部分 -->
    <div class="table-data-box">
      <div class="button-box" style="margin-top: 20px">
        <div class="float-left-button">
          <div v-zoom="{ from: pageName, name: '发送短信' }" class="button button-status1" @click="sandSmsNow('send')">
            <img class="icon_sms" src="../../assets/images/icon_sms.png" alt />
            <span class="button-title">发送短信</span>
          </div>
          <div v-zoom="{ from: pageName, name: '按查询结果发送短信' }" class="button button-status3" @click="seachResult('black')">
            <span class="button-title">按查询结果发送短信</span>
          </div>
          <div v-zoom="{ from: pageName, name: '打标签' }" class="button button-status2" v-if="labelManagePower" @click="toAddLabelMore">
            <span class="button-title">打标签</span>
          </div>
          <div
            v-zoom="{ from: pageName, name: '按查询结果打标签' }"
            class="button button-status2"
            v-if="labelManagePower"
            @click="toAddLabelMoreResult"
          >
            <span class="button-title">按查询结果打标签</span>
          </div>
        </div>
        <div class="float-right-button">
          <div v-zoom="{ from: pageName, name: '添加会员' }" @click="addMember = true" class="button button-status3">
            <!-- 添加会员 -->
            <!-- <img src="@/assets/images/member/icon_add.png" /> -->
            <span class="button-title">添加会员</span>
          </div>
          <div v-zoom="{ from: pageName, name: '导入会员资料' }" @click="importMenberData = true" class="button button-status2">
            <!-- 导入会员资料 -->
            <!-- <img src="@/assets/images/member/icon_import.png" /> -->
            <span class="button-title">导入会员资料</span>
          </div>
          <div v-zoom="{ from: pageName, name: '添加黑名单' }" @click="JoinBackListShow" class="button button-status2">
            <!-- 添加黑名单 -->
            <!-- <img src="@/assets/images/member/icon_blacklist.png" /> -->
            <span class="button-title">添加黑名单</span>
          </div>
          <div v-zoom="{ from: pageName, name: '删除会员' }" @click="handleDeleteTabletake" class="button button-status2">
            <!-- <img src="@/assets/images/member/icon_del.png" /> -->
            <span class="button-title">删除</span>
          </div>
          <!-- <div @click="export_member()" class="icon_wrap"> -->
          <!-- 导出会员 -->
          <!-- <img
              src="@/assets/images/member/icon_blacklist.png"
            />
          </div>-->
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="table-box">
        <!-- @sort-change="changeTableSort" 排序 -->
        <el-table
          v-loading="talbeLoading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="light"
          stripe
          @sort-change="changeTableSort"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; border: 1px solid #eee"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left:-140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" width="50" fixed></el-table-column>
          <el-table-column prop="desensitizePin" label="买家账号" width="120">
            <!-- <template slot-scope="scope">
              {{ scope.row.encryptPin }}
            </template> -->
          </el-table-column>
          <el-table-column prop="fullName" label="买家姓名">
            <template slot-scope="scope">
              <div class="show-box" v-if="!scope.row.fullNameState">
                <span>{{ scope.row.fullName }}</span>
                <!-- <div
                  class="hover-show"
                  @click="showInfo(1, scope.row, scope.$index)"
                  style="width: 110px"
                  :style="{ background: globalBG }"
                >
                  显示买家姓名
                </div> -->
              </div>
              <div v-else>{{ scope.row.fullName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="会员等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade == 1">一星会员</span>
              <span v-else-if="scope.row.grade == 2">二星会员</span>
              <span v-else-if="scope.row.grade == 3">三星会员</span>
              <span v-else-if="scope.row.grade == 4">四星会员</span>
              <span v-else-if="scope.row.grade == 5">五星会员</span>
              <span v-else>非会员</span>
            </template>
          </el-table-column>
          <el-table-column label="地区" min-width="120">
            <template slot="header" slot-scope="scope">
              <span>地区</span>
              <span class="table-message" v-if="!allShow" :style="{ color: globalBG }" @click="allShow = true">(展开全部)</span>
              <span class="table-message" v-if="allShow" :style="{ color: globalBG }" @click="allShow = false">(单行显示)</span>
            </template>
            <template slot-scope="scope">
              <div class="show-box" v-if="!scope.row.fullAddressState">
                <el-tooltip class="item" effect="light" :content="scope.row.fullAddress" placement="bottom">
                  <div class="hoveTitle" v-show="!allShow">
                    {{ scope.row.fullAddress }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  {{ scope.row.fullAddress }}
                </div>

                <!-- <div
                  class="hover-show"
                  @click="showInfo(2, scope.row, scope.$index)"
                  style="width: 110px"
                  :style="{ background: globalBG }"
                >
                  显示地区
                </div> -->
              </div>
              <div v-else>
                <el-tooltip class="item" effect="light" :content="scope.row.fullAddress" placement="bottom">
                  <div class="hoveTitle" v-show="!allShow">
                    {{ scope.row.fullAddress }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  {{ scope.row.fullAddress }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号码" width="115">
            <template slot-scope="scope">
              <div class="show-box">
                <span>{{ (scope.row.mobile || "--") | mobileEllipsis }}</span> -->
          <!-- <div
                  class="hover-show"
                  @click="showInfo(3, scope.row, scope.$index)"
                  style="width: 110px"
                  :style="{ background: globalBG }"
                >
                  显示手机号码
                </div> -->
          <!-- </div> -->
          <!-- <div v-else>{{ scope.row.mobile || "--" }}</div> -->
          <!-- </template>
          </el-table-column> -->
          <el-table-column prop="buyTotalMoney" label="交易总额" sortable width="120"></el-table-column>
          <el-table-column prop="buyTotalCount" label="购买次数" sortable width="100"></el-table-column>
          <el-table-column prop="avgPrice" label="客单价" sortable width="100"></el-table-column>
          <el-table-column prop="dormancyDays" label="未购买天数" sortable width="120"></el-table-column>
          <el-table-column label="标签" width="160" v-if="labelManagePower">
            <template slot-scope="scope">
              <div>
                <div style="width: 120px; float: left">
                  <div v-for="(item, index) in scope.row.labelList" :key="index" class="toTips2 label-btn" v-if="index < 4">
                    <span style="">{{ item.labelName }}</span>
                    <i @click="sureDelect(item, scope.row.labelList, scope.row)"></i>
                    <!-- <el-tooltip :content="item.labelName" placement="left-start">
                  <span>{{item.labelName}}</span>
                </el-tooltip>-->
                  </div>
                </div>
                <div style="float: right; margin-top: 5px">
                  <i @click="addLabel(scope.row)" :style="{ color: globalBG }" class="el-icon-circle-plus label-add"></i>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="buyerLastTime" label="最后交易时间" min-width="150" sortable :show-overflow-tooltip="true"></el-table-column>

          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                @click="handleDetail(scope.$index, scope.row)"
                :style="{ width: 'auto' }"
              >              </el-button> -->
              <span
                class="titiecolor"
                style="margin-left: 10px"
                v-zoom="{ from: pageName, name: '详情' }"
                @click="handleDetail(scope.$index, scope.row)"
                >详情</span
              >

              <!-- <el-button
                type="text"
                @click="handleReport(scope.$index, scope.row)"
                :style="{ color: globalBG, margin: 0, width: 'auto' }"
              > -->
              <span
                style="margin-left: 10px"
                v-zoom="{ from: pageName, name: '交易记录' }"
                @click="handleReport(scope.$index, scope.row)"
                class="titiecolor"
                >交易记录</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="float: right; top: 10px; position: relative"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formDataList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalList"
          :current-page="formDataList.current"
        ></el-pagination>
        <div style="height: 50px"></div>
      </div>
    </div>
    <!-- 选择标签 -->
    <select-label :labelState="labelState" :selectIdsArr="selectIdsArr" @transferName4="transferName4"></select-label>

    <!-- 发送短信 -->
    <send-sms
      :drawer="drawer"
      @close="drawerClose"
      taskName="会员发送"
      :checkData="multipleSelection"
      :sendType="sendType"
      :count="checkCount"
      :dataFrom="1"
      :dataFromStr="'会员列表'"
      :searchForm="searchParams"
      :isMedialSms="true"
      @onViewRecord="handleViewRecord"
      @onConSending="drawerClose"
    ></send-sms>
    <!-- 发送短信 模态框 -->
    <!-- <send-message
      v-if="sendMsg"
      @transferName="sendMessageBtn"
      :shopBuyerCount="countSmsNum"
      :seachLength="countSmsNum.length"
      :sendType="1"
      :checkedMemberArr="phoneData"
      :showQueryBtn="true"
      :themeText="'会员发送'"
      :showSendPhone="showSendPhone"
      :sendInnerType2="sendInnerType2"
      :hideOption="true"
    ></send-message> -->
    <!-- 按查询结果发送短信 -->
    <!-- <send-message
      v-if="bothSendMsg"
      @transferName="bothSendMessageBtn"
      :seacherData="sendChooseList"
      :seachLength="totalList"
      :sendType="1"
      :themeText="'会员发送'"
      :showSendPhone="showSendPhone"
      :sendInnerType2="sendInnerType2"
      :hideOption="true"
    ></send-message> -->
    <!--导出数据弹窗-->
    <el-dialog title="导出数据" :visible.sync="exportDialog" width="670px">
      <div class="contentTwo">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checksAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="exportData" @change="handleCheckedexport" style="margin: 20px 0 0">
          <el-checkbox v-for="(item, index) in exportOpt" :key="index" :label="index" style="margin: 5px 20px 0 0">{{ item }}</el-checkbox>
        </el-checkbox-group>

        <div class="clear-float" style="width: 320px; margin: 40px auto 20px">
          <div class="twoContent-one" :style="{ 'background-color': globalBG }" @click="exportsData()">
            导出
          </div>
          <div class="twoContent-two" @click="exportDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>

    <!--导出数据的短信验证-->
    <el-dialog title="短信" :visible.sync="sendDialog" width="400px" style="min-width: 1200px">
      <template slot="title">
        <span>身份验证</span>
      </template>
      <div class="export-dialog-wrapper">
        <div class="sendHug">
          <span class="font_family icon-gantanhao" style="margin-left: 12px; font-size: 14px; margin-right: 10px"></span>
          <span>为了保护您的数据安全，导出数据需要手机验证</span>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 28px">手机号：</div>
          <div class="send-right">
            <span>
              <span>{{ phone }}</span>
              <span
                style="
                  margin-left: 30px;
                  color: #24a0da;
                  line-height: 28px;
                  cursor: pointer;
                "
                @click="toChangePhone"
                >修改</span
              >
            </span>
          </div>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 28px">验证码：</div>
          <div class="send-right send-right2">
            <input type="tel" class="codeBtn" v-model="code" placeholder="请输入验证码" style />
            <input type="button" class="getNumber" v-model="codeMsg" @click="getCode" :disabled="codeDisabled" />
          </div>
        </div>
        <div class="hug-send" style="margin-top: 5px">
          <div class="msg" style="height: 15px">{{ successMsg }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="sureExport" style="width: 100px">确定</el-button>
        <el-button @click="sendDialog = false" size="small" style="width: 100px">取消</el-button>
      </span>
    </el-dialog>
    <export-dialog v-if="dialogSureExport" :status="exportStatus" @transData="(val) => (dialogSureExport = val)"></export-dialog>
    <!-- 添加客户弹窗 -->
    <add-customer v-if="addMember" ref="addCustomer" @cancel="cancelAdd" @addUserData="addUserData"></add-customer>

    <!-- 加入黑名单弹窗 -->
    <my-popup title="提示" width="400" :flag="joinBlackList" @close="joinBlackList = false">
      <div class="JoinBackList">
        <div class="tipsBox">
          <img src="@/assets/images/tips_icon.png" class="tips" style="margin-left: 220px; width: 22px; height: 22px" />
          <span>确定拉黑会员?</span>
        </div>
        <div class="btnBox">
          <el-button @click="joinBlackList = false" class="cancelBtn">取消</el-button>
          <el-button @click="handleJoinBackList" v-loading="joinBlackLoading" class="confirmBtn" style="margin-right: 150px">确定</el-button>
        </div>
      </div>
    </my-popup>

    <!-- 会员详情弹窗 -->
    <member-detail :isShow="showDetail" :data="memberDetail" @close="showMemberDetailBtn"></member-detail>

    <!-- 批量删除弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否确定删除？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除标签弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible1" width="400px" :before-close="closehandleDelete1"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 50px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 80px; font-size: 14px">此操作将永久删除该标签, 是否继续？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete1">取 消</el-button>
        <el-button class="b2" @click="handleDelete">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导入会员资料 -->
    <my-popup title="导入会员资料" width="730" :flag="importMenberData" @close="handleImportMenber">
      <div class="importMenberData">
        <p>选择文件</p>
        <div class="import">
          <el-input disabled v-model="downloadName"></el-input>
          <el-upload
            class="upload-demo"
            ref="uploadMenber"
            action=""
            accept=".xls,.xlsx"
            :auto-upload="false"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-change="uploadChange"
            :limit="1"
          >
            <el-button size="small" class="button-status1">选择文件</el-button>
          </el-upload>
        </div>
        <p class="tips">
          <i class="el-alert__icon el-icon-info"></i>
          文件不能超过50M！（只支持xlsx、xls两种类型的上传文件）
        </p>
        <div class="btnBox">
          <button class="download" @click="downloadTemp">下载模板</button>
          <div>
            <button class="cancelBtn" @click="handleImportMenber">取消</button>
            <button class="confirmBtn" @click="handleAvatarSuccess">
              确定
            </button>
          </div>
        </div>
      </div>
    </my-popup>
  </div>
</template>

<script>
import selectLabel from "@/components/select-label.vue";
import inputSKU from "@/components/Form/inputSKU.vue";
import cityPopover from "@/components/city-popover.vue";
import cityPopoverX from "@/components/city-popover-x.vue";
import exportDialog from "@/components/export-dialog";
import MemberDetail from "./components/menber_detail";
// import SendMessage from "@/components/send-message";
import sendSms from "@/views/serviceCenter/components/sendSms";
import addCustomer from "@/components/add-customer";
import myPopup from "@/components/myPopup";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  updateLabelByCondition,
  batchAddLabelByQuery,
  batchInsertLabel,
  judgeShopBuyerGrade,
  exportMemberList,
  getCommonLabel,
  // getMemberDetail,
  getMemberList,
} from "@/api/manage/memberListController";
import { insertBlack } from "@/api/smsBlackList";
import { sendSmsVerifyCode } from "@/api/public";
import { getCommonBuyerLabel, addMemberUser, delMenber, getMemberDetail, uploadFile, shopDetail } from "@/api/shopBuyer";

export default {
  name: "focusShop",
  components: {
    selectLabel,
    cityPopover,
    sendSms,
    // SendMessage,
    exportDialog,
    addCustomer,
    MemberDetail,
    myPopup,
    cityPopoverX,
    inputSKU
  },
  data() {
    return {
      pageName: "客户管理-会员列表",
      joinBlackLoading: false,
      sendChooseList: "",
      labelManagePower: true, // 判断客户是否有标签管理权限
      selectIdsArr: [], // 选择的标签
      selectSearchIds: [], // 查询接口的选择标签
      totalList: null,
      pinsid: "",
      item: [],
      listArr: [],
      dataArr: [],

      memberList: [
        {
          value: 6,
          label: "非会员",
        },
        {
          value: 1,
          label: "一星会员",
        },
        {
          value: 2,
          label: "二星会员",
        },
        {
          value: 3,
          label: "三星会员",
        },
        {
          value: 4,
          label: "四星会员",
        },
        {
          value: 5,
          label: "五星会员",
        },
      ],
      isInit: false,
      outerVisible: false, //批量删除弹框
      outerVisible1: false, //删除标签弹框

      /**
       * 选择地区相关数据
       */
      checkedList: [],
      cityShow: false,
      talbeLoading: false,
      tableData: [], // 表格内容
      multipleSelection: [], // 表格多选
      // 存储复选框选中人数
      checkCount: 0,
      sendType: 1, // 发送类型 1. 按条件查询 2.勾选
      allShow: false, // 信息是否全部显示
      bothSendMsg: false, // 按查询结果发送短信 模态框
      /**
       * 添加会员 模态框
       */
      showSendPhone: true, // 控制send-message中的 发送号码 显示或隐藏
      // 导入会员资料弹窗状态控制
      importMenberData: false,
      downloadName: null,
      uploadFile: null,
      phoneData: [],
      sendInnerType2: "member-list", // send-message中的标签显示哪个
      drawer: false, // 发送短信 模态框
      joinBlackList: false, // 加入黑名单 模态框
      pointsMemberObj: null, // 添加或者删除标签的数据
      addLabelType: "", // 判断是哪里新增标签的
      addShopBuyerId: "", // 要添加标签的会员id
      addBuyerNicks: "", // 要添加标签的会员昵称
      labelType: -1, // 判断哪里点击的选择标签
      selectIdsArr2: [], // 标签弹窗参数，显示已选的标签
      labelState: false, // 显示标签弹窗
      addResult: false, // 判断是点击 按查询结果打标签(true)，还是 打标签(false) 按钮
      searchParams: {}, // 查数据的参数
      checksAll: true,
      exportData: [], // 选择的导出字段
      exportDialog: false, // 导出会员弹窗
      isIndeterminate: true, // 是否全选
      code: "", // 验证码
      phone: "", //客户的手机号
      codeMsg: "获取验证码", // 按钮上的文字
      codeDisabled: false, // 按钮可点击？（是否绑定手机）
      timer: null, // 验证码定时
      successMsg: "",
      countdown: 60, // 倒计时秒数
      sendDialog: false, // 短信验证弹窗
      exportDialog: false, // 导出会员弹窗
      exportStatus: false,
      dialogSureExport: false,
      addMember: false,
      labelListArr: [],
      memberDetail: "",
      showDetail: false,
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formDataList.startBuyerLastTime) {
            return time.getTime() < new Date(this.formDataList.startBuyerLastTime).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formDataList.endBuyerLastTime) {
            return time.getTime() > new Date(this.formDataList.endBuyerLastTime).getTime();
          } else {
          }
        },
      },
      exportOpt: ["买家昵称", "买家姓名", "会员等级", "地区", "手机号码", "交易总额", "交易次数", "未购买天数", "最后购买时间"], //导出项
      formDataList: {
        skuIds: "", // 指定SKU
        // labelIds: "",
        // buyerLabelId: "",
        pin: "",
        startBuyTotalCount: "",
        startBuyTotalMoney: "",
        startBuyerLastTime: "",
        endBuyTotalCount: "",
        endBuyTotalMoney: "",
        endBuyerLastTime: "",
        grades: [],
        current: 1,
        size: 10,
        mobile: "",
        pin: "",
        province: "",
        mytimestart: "",
        mytimeend: "",
        labelType: 1,
        buyerLastTime: "Customized",
        orderField: "", // 交易总额 buy_total_money，购买总次数 buy_total_count，最后购买时间（最后交易时间） buyer_last_time
        orderType: "", //asc 升序，desc 降序 ,
      },
      // provinces: [],
    };
  },
  created() {
    this.istime();
    this.getData();
    // 调用埋点接口
    this.buriedPoint(1, '会员列表', '客户管理', '会员管理')
  },
  mounted() {
    if (this.$route.query.labelList) {
      this.selectSearchIds.push(Number(this.$route.query.labelList));
      this.selectIdsArr = JSON.parse(JSON.stringify(this.selectSearchIds));
      // this.selectIdsArr.push(Number(this.$route.query.labelList));
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  methods: {
    ...mapMutations(["MODELTITLE"]),
    getLocation(val, state) {
      if (state == "cancel") {
        return;
      }
      this.checkedList = val;
    },
    showInfo(type, row, index) {
      var param = {
        pin: row.pin,
        detatilType: type,
      };
      shopDetail(param).then((res) => {
        if (res.code == "1") {
          if (type == "1") {
            // 买家姓名
            this.tableData[index].fullName = res.data.fullName;
            this.tableData[index].fullNameState = true;
          } else if (type == "3") {
            // 手机号码
            this.tableData[index].mobile = res.data.mobile;
            this.tableData[index].fullMobileState = true;
          } else if (type == "2") {
            // 地区
            this.tableData[index].fullAddress = res.data.fullAddress;
            this.tableData[index].fullAddressState = true;
          } else if (type == "0") {
            // 买家账号
            this.tableData[index].encryptPin = res.data.pin;
            this.tableData[index].fullPinState = true;
          }
        }
      });
    },
    handleViewRecord() {
      // console.log(this.$parent);
    },
    istime() {
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
      this.formDataList.startBuyerLastTime = this.getDateStr(-30) + " 00:00:00";
      this.formDataList.endBuyerLastTime = this.mytimeend;
    },
    // 查询表格数据
    getData(obj) {
      let form = this.deepCopy(this.formDataList);
      // if (form.province === "Customized") form.customArea = this.checkedList;
      if (form.province === "Customized") form.cites = this.checkedList.join(",");
      // form.labelIds = this.selectIdsArr;
      form.labelIds = this.selectSearchIds;
      form.skuIds = form.skuIds.length > 0 ? form.skuIds.split(",") : [];
      this.searchParams = form;
      this.talbeLoading = true;
      getMemberList(form)
        .then((res) => {
          this.tableData = res.data.records;
          this.totalList = res.data.total;
          this.talbeLoading = false;
          // console.log(this.tableData);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 排序
    changeTableSort(ev) {
      /*
       * orderField：buy_total_money 交易总额，buy_total_count 购买总次数，avg_price 平均客单价，dormancy_days 未购买天数，buyer_last_time 最后购买时间（最后交易时间）
       * orderType：排序方式：asc 升序，desc 降序
       */
      console.log(ev);
      if (ev.prop === "buyTotalMoney") {
        this.formDataList.orderField = "buy_total_money"; //交易总额
      } else if (ev.prop === "buyTotalCount") {
        this.formDataList.orderField = "buy_total_count"; //购买总次数
      } else if (ev.prop === "buyerLastTime") {
        this.formDataList.orderField = "buyer_last_time"; //最后交易时间
      } else if (ev.prop === "avgPrice") {
        this.formDataList.orderField = "avg_price"; //客单价
      } else if (ev.prop === "dormancyDays") {
        this.formDataList.orderField = "dormancy_days"; //未购买天数
      }

      if (ev.order === "descending") {
        this.formDataList.orderType = "desc"; //降序
      } else if (ev.order === "ascending") {
        this.formDataList.orderType = "asc"; // 升序
      } else {
        this.formDataList.orderType = ""; //默认
        this.formDataList.orderField = "";
      }
      this.getData();
    },

    oninput(val) {
      if (val && val <= 0) {
        val = "";
      }
      return val.replace(/\./g, "");
    },
    startBuyTotalMoneystart(val) {
      var max = this.formDataList.endBuyTotalMoney;
      if (max && val >= max) {
        this.formDataList.startBuyTotalMoney = "";
        this.$message.warning("交易总额开始值不能大于结束值");
      }
    },

    startBuyTotalMoneyend(val) {
      var min = this.formDataList.startBuyTotalMoney;
      if (min && +min >= +val) {
        this.formDataList.endBuyTotalMoney = "";
        this.$message.warning("交易总额开始值不能大于结束值");
      }
    },

    changeTotalCountStart(val) {
      var max = this.formDataList.endBuyTotalCount;
      if (max && val >= max) {
        this.formDataList.startBuyTotalCount = "";
        this.$message.warning("购买次数开始值不能大于结束值");
      }
    },

    changeTotalCountEnd(val) {
      var min = this.formDataList.startBuyTotalCount;
      if (min && +min > +val) {
        this.formDataList.endBuyTotalCount = "";
        this.$message.warning("购买次数结束值不能小于开始值");
      }
    },

    changeTotalMoneyStart(val) {
      var max = this.formDataList.endAvgPrice;
      if (max && val >= max) {
        this.formDataList.startAvgPrice = "";
        this.$message.warning("交易预算开始值不能大于结束值");
      }
    },

    changeTotalMoneyEnd(val) {
      var min = this.formDataList.startAvgPrice;
      if (min && +min >= +val) {
        this.formDataList.endAvgPrice = "";
        this.$message.warning("交易预算结束值不能小于开始值");
      }
    },

    // startBuyerLastTimestart(val) {
    //   var max = this.formDataList.endBuyerLastTime;
    //   if (max && val >= max) {
    //     this.fformDataList.startBuyerLastTime = "";
    //     this.$message.warning("交易预算开始值不能大于结束值");
    //   }
    // },

    // startBuyerLastTimeend(val) {
    //   var min = this.formDataList.startBuyerLastTime;
    //   if (min && +min >= +val) {
    //     this.formDataList.endBuyerLastTime = "";
    //     this.$message.warning("交易预算结束值不能小于开始值");
    //   }
    // },

    // 交易记录事件
    handleReport(index, row) {
      console.log(row);
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/order_sent",
        query: {
          to: "/manage/manage/focusShop",
          data: JSON.stringify(row),
          focusShop: true,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    //批量删除弹窗
    handleDeleteTabletake(val) {
      if (this.tableData.length == 0) {
        this.$message.warning("表格数据为空");
        return;
      }
      if (val && this.multipleSelection.length == 0) {
        this.$message.warning("请选择一个选项");
        return;
      }
      this.outerVisible = true;
      const pins = this.multipleSelection.map((item) => item.pin);
      this.pinsid = pins;
    },
    //关闭批量删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    //关闭删除标签弹框
    closehandleDelete1() {
      this.outerVisible1 = false;
      this.$message.warning("已关闭删除");
    },
    // 批量删除
    handleDeleteTable() {
      this.outerVisible = false;

      const pins = this.pinsid;
      delMenber(pins)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("删除成功");
            this.getData();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.info("已取消删除");
        });
    },

    // 买家详情模态框事件
    handleDetail(index, row) {
      this.labelListArr = row.buyerLabelDTOList;
      getMemberDetail({ pin: row.pin })
        .then((res) => {
          if (res.code == 1) {
            this.memberDetail = res.data;
            this.showDetail = true;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 关闭详情模态框
    showMemberDetailBtn(data) {
      this.showDetail = false;
      this.getData();
      // if (data === "refresh") {
      //   this.seacherResult();
      // }
    },

    // 导入会员资料
    routerLink() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/addinfo" },
      });
      window.open(routeUrl.href, "_blank");
    },

    cancelAdd() {
      this.addMember = false;
      this.clearTable();
    },
    JoinBackListShow() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择一个选项");
        return;
      }
      this.joinBlackList = true;
    },
    // 加入黑名单确定
    handleJoinBackList() {
      const pins = this.multipleSelection.map((item) => item.pin);
      const params = {
        pins,
        type: 1,
      };
      this.joinBlackLoading = true;
      insertBlack(params).then((res) => {
        this.joinBlackLoading = false;
        if (res.data.sucessNum > 0) {
          let mes = `添加成功${res.data.sucessNum}个，失败${res.data.fialNum}个`;
          this.$message.success(mes);
          this.getData();
          this.joinBlackList = false;
        } else if (res.data.sucessNum <= 0) {
          this.$message.error("重复添加");
          this.joinBlackList = false;
        } else {
          this.$message.error("添加失败");
          this.joinBlackList = false;
        }
      });
    },
    //清空表格的数据
    clearTable() {
      this.$refs.addCustomer.addFormData = {
        buyTotalCount: "",
        buyTotalMoney: "",
        pin: "",
        fullAddress: "",
        mobile: "",
        fullName: "",
        province: "",
      };
    },

    export_member() {
      this.checksAll = false;
      this.exportData = [];
      this.exportDialog = true;
    },

    handleCheckAllChange(val) {
      this.exportData = val ? [0, 1, 2, 3, 4, 5, 6, 7, 8] : [];
      this.isIndeterminate = false;
    },

    handleCheckedexport(value) {
      console.log(value);
      let checkedCount = value.length;
      this.checksAll = checkedCount === this.exportOpt.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.exportOpt.length;
    },

    exportsData() {
      //导出事件
      this.code = "";
      clearInterval(this.timer);
      this.codeMsg = "获取验证码";
      this.countdown = 60;
      this.timer = null;
      if (this.exportData.length == 0) {
        this.$message("没有选择导出字段");
      } else {
        this.sendDialog = true; //显示短信验证
        this.exportDialog = false; //导出弹窗隐藏
      }
    },

    getCode() {
      // 验证码60秒倒计时
      if (!this.timer) {
        let obj = {
          mobile: this.phone,
          sendType: 5,
        };
        sendSmsVerifyCode(obj).then((res) => {
          if (res.code == 200) {
            this.successMsg = res.message;
          }
        });
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },

    sureExport() {
      //验证后导出数据
      if (this.code == "") {
        this.$message("请输入验证码");
        return;
      }
      let exports = this.exportData.join(",");
      let obj = {
        vcode: this.code,
        memberParamDTO: this.formDataList,
        exportCellType: exports,
      };
      console.log(obj);
      this.exportStatus = false;
      exportMemberList(obj)
        .then((res) => {
          if (res.code == 200) {
            this.exportStatus = true;
          } else {
            this.dialogSureExport = false;
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.dialogSureExport = false;
        });
      this.dialogSureExport = true;
      this.sendDialog = false;
    },

    toChangePhone() {
      //跳转到帐号设置绑定手机
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: {
          to: "/backstage/accountset",
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 发送短信模态框
    drawerClose() {
      this.drawer = false;
    },

    // 根据查询条件取公共标签
    getCommonLabel() {
      let obj = this.searchParams;
      getCommonBuyerLabel(obj)
        .then((res) => {
          if (res.code == 1) {
            this.labelType = 1;
            this.selectIdsArr = res.data.buyerLabelVOList.map((item) => item.id);
            this.labelState = true;
          } else if (res.code == 0) {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //清除时间
    clearTimeSendTime() {
      this.formDataList.startBuyerLastTime = "";
      this.formDataList.endBuyerLastTime = "";
    },
    // 点击 按查询结果打标签 按钮
    toAddLabelMoreResult() {
      this.addResult = true;
      this.addLabelType = 2;
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message.info("请选择打标签的会员");
        return;
      }
      let idsArr = [];
      let nickArr = [];
      this.tableData.forEach((item) => {
        idsArr.push(item.id);
        nickArr.push(item.pins);
      });
      this.addShopBuyerId = idsArr;
      // 去重
      nickArr = Array.from(new Set(nickArr));
      this.addBuyerNicks = nickArr;
      console.log("要批量打标签的id", this.addShopBuyerId);
      this.labelType = 1;
      // this.getRetainLabelIds(this.addBuyerNicks); // 查询勾选项的公有标签
      this.getCommonLabel();
    },
    // 批量打标签
    toAddLabelMore() {
      this.addResult = false;
      this.addLabelType = 2;
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择打标签的会员");
        return;
      }
      let idsArr = [];
      let pins = [];
      this.multipleSelection.forEach((item) => {
        idsArr.push(item.id);
        if (item.pin) {
          pins.push(item.pin);
        }
      });
      this.addShopBuyerId = idsArr;
      pins = Array.from(new Set(pins));
      this.addBuyerNicks = pins;
      this.labelType = 1;
      this.getRetainLabelIdsMethod(encodeURI(pins)); // 查询勾选项的公有标签
    },
    // 查询勾选项的公有标签
    getRetainLabelIdsMethod(pins) {
      //  let obj = this.searchParams;
      if (pins && pins.indexOf(",") != "-1") {
        pins = pins.split(",");
      } else {
        pins = [pins];
      }

      getCommonBuyerLabel({ pins, current: 1, size: 10 })
        .then((res) => {
          if (res.code == 1) {
            this.selectIdsArr = res.data.buyerLabelVOList.map((item) => item.id);
            this.labelState = true;
          }
        })
        .catch((err) => {});
    },

    // 按查询结果发送短信 模态框
    bothSendMessageBtn() {
      this.bothSendMsg = false;
      // if (event.type == 2) {
      //   this.sendMessage = event.obj;
      //   this.confirmState = true;
      // }
    },

    // 发送短信
    sandSmsNow(val) {
      if (this.tableData.length == 0) {
        this.$message.warning("表格数据为空");
        return;
      }
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择一个选项");
        return;
      }
      if (this.multipleSelection.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.sendType = 2;
      this.checkCount = this.multipleSelection.length;
      this.drawer = true;
      // if (this.multipleSelection.length > 0) {
      //   let obj = {
      //     flag: false,
      //     type: "",
      //     name: "营销模板",
      //     chirdrenName: ""
      //   };
      //   this.MODELTITLE(obj);
      //   this.countSmsNum = this.multipleSelection;
      //   this.phoneData = this.multipleSelection;
      //   if (val === "send") {
      //     this.showSendPhone = false; // 控制send-message中的 发送号码 显示或隐藏
      //     this.sendMsg = true;
      //   } else {
      //     this.joinBlackList = true;
      //   }
      // } else {
      //   this.$message.error("请选择加入黑名单的会员");
      // }
    },

    seachResult() {
      if (this.tableData.length == 0) {
        this.$message.warning("表格数据为空");
        return;
      }
      if (this.tableData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.sendType = 1;
      this.checkCount = this.totalList;
      this.drawer = true;
      // console.log(this.formDataList);
      // let obj = {
      //   flag: false,
      //   type: "",
      //   name: "营销模板",
      //   chirdrenName: ""
      // };
      // this.MODELTITLE(obj);
      // this.sendChooseList = { memberParamDTO: this.formDataList }; //smsSendBuyerParamDTO
      // this.showSendPhone = false; // 控制send-message中的 发送号码 显示或隐藏
      // this.bothSendMsg = true;
    },

    handleCurrentChange(val) {
      this.formDataList.current = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.formDataList.size = val;
      this.formDataList.current = 1;
      this.getData();
    },

    // 监听表格多选事件
    handleSelectionChange(val) {
      // console.log(val);
      this.multipleSelection = val;
    },

    // 排序
    // changeTableSort(ev) {
    //   /*
    //    * sortPosition  排序方向 0:降序 1:升序 ,
    //    * sortType (string, optional): 排序类型 0:交易总额 1:交易次数 2:未购买天数 3:最后购买时间 ,
    //    */
    //   if (ev.order === "descending") {
    //     this.formDataList.sortPosition = "0";
    //   } else if (ev.order === "ascending") {
    //     this.formDataList.sortPosition = "1";
    //   } else {
    //     this.formDataList.sortPosition = "";
    //   }

    //   if (ev.prop === "buyTotalMoney") {
    //     this.formDataList.sortType = "0";
    //   } else if (ev.prop === "buyTotalCount") {
    //     this.formDataList.sortType = "1";
    //   } else if (ev.prop === "notBuyTime") {
    //     this.formDataList.sortType = "2";
    //   } else if (ev.prop === "buyerLastTime") {
    //     this.formDataList.sortType = "3";
    //   }
    //   this.getData();
    // },

    // 新增会员
    addUserData(form) {
      addMemberUser(form)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("添加成功");
            this.addMember = false;
            this.clearTable();
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 查詢结果
    seacherResult() {
      if (this.formDataList.receiverZips == "0" && this.checkedList.length == 0) {
        this.formDataList.receiverZips = "";
      } else if (this.formDataList.receiverZips == "1") {
        this.formDataList.receiverZips = "1";
      } else if (this.formDataList.receiverZips == "2") {
        this.formDataList.receiverZips = "2";
      }
      this.formDataList.current = 1;
      this.getData();
    },

    // 重置
    resetList() {
      // 清空数据

      this.formDataList.fullName = "";
      this.formDataList.startAvgPrice = "";
      this.formDataList.endAvgPrice = "";
      this.formDataList.skuIds = "";
      this.formDataList.pin = "";
      this.formDataList.startBuyTotalCount = "";
      this.formDataList.startBuyTotalMoney = "";
      this.formDataList.startBuyerLastTime = "";
      this.formDataList.endBuyTotalCount = "";
      this.formDataList.endBuyTotalMoney = "";
      this.formDataList.endBuyerLastTime = "";
      this.formDataList.grades = [];
      this.formDataList.current = 1;
      this.formDataList.size = 10;
      this.formDataList.mobile = "";
      this.formDataList.pin = "";
      this.formDataList.province = "";
      this.formDataList.labelType = 1;
      this.formDataList.labelIds = [];
      this.formDataList.buyerLastTime = "Customized";
      this.selectSearchIds = [];
      this.getData();
    },
    //点击自定义时是否显示
    changeCityShow() {
      this.cityShow = true;
    },

    // 按查询结果打标签
    updateLabelByCondition(val) {
      let obj = this.searchParams;
      let addArr = [];
      let delArr = [];
      // 新增标签的数组
      val.forEach((item) => {
        let num = 0;
        this.selectIdsArr.forEach((item2) => {
          if (item == item2) {
            num = num + 1;
          }
        });
        if (num == 0) {
          addArr.push(item);
        }
      });

      // 删除标签的数组
      this.selectIdsArr.forEach((item) => {
        let number = 0;
        val.forEach((item2) => {
          if (item == item2) {
            number = number + 1;
          }
        });
        if (number == 0) {
          delArr.push(item);
        }
      });

      (obj.addLabelIdList = addArr), (obj.delLabelIdList = delArr), console.log(obj, "obj");
      // console.log("参数obj====",obj);
      batchAddLabelByQuery(obj).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.message);
          this.formDataList.current = 1;
          this.formDataList.size = 10;
          this.getData(); // 按查询结果打标签后查数据
        }
      });
    },

    // 删除标签前的确认
    sureDelect(item, listArr, dataArr) {
      // this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   dangerouslyUseHTMLString: true,
      //   type: "warning",
      // })
      // .then(() => {
      this.item = item;
      this.dataArr = dataArr;
      this.listArr = listArr;
      this.outerVisible1 = true;
      // this.handleDelete();
      // })
      // .catch(() => {
      //   this.$message.info("已取消删除");
      // });
    },

    // 删除标签
    handleDelete() {
      this.outerVisible1 = false;
      const row = this.item;
      const listArr = this.listArr;
      const dataArr = this.dataArr;
      const labelList = dataArr.labelList.map((item) => item.labelId);
      const index = labelList.indexOf(row.labelId);
      let delArr = labelList.splice(index, 1);
      // this.addShopBuyerId = dataArr.shopBuyerId;
      this.addLabelType = 3;
      this.addBuyerNicks = dataArr.pin;
      this.batchInsertLabel(1, {
        delArr,
        addArr: labelList,
      });
    },

    // 批量打标签
    batchInsertLabel(ind, val) {
      console.log(val);
      console.log(this.selectIdsArr2);
      let addArr = [];
      let delArr = [];
      if (ind == 2) {
        addArr = val;
        // 新增标签的数组
        // val.forEach(item => {
        //   const state = this.selectIdsArr2.includes(item);
        //   if(!state) {
        //     addArr.push(item);
        //   }
        // })

        // 删除标签的数组
        this.selectIdsArr &&
          this.selectIdsArr.forEach((item) => {
            const state = val.includes(item);
            if (!state) {
              delArr.push(item);
            }
          });
      } else if (ind == 1) {
        delArr = val.delArr;
        addArr = val.addArr;
      }
      let params = {
        pins: Array.isArray(this.addBuyerNicks) ? this.addBuyerNicks : [this.addBuyerNicks],
        addLabelIdList: addArr,
        delLabelIdList: delArr,
      };

      batchInsertLabel(params).then((res) => {
        if (res.code == 1) {
          if (this.addLabelType == 1) {
            this.$message.success("标签修改成功");
          } else if (this.addLabelType == 2) {
            this.$message.success("批量打标成功");
          } else if (this.addLabelType == 3) {
            this.$message.success("标签删除成功");
          }
        }
        this.getData(); // 添加标签后查数据
      });
    },

    // 添加标签
    addLabel(val) {
      console.log("addLabel", val);
      this.addLabelType = 1;
      this.labelType = 1;
      let idsArr = val.labelList && val.labelList.map((item) => item.labelId);

      this.selectIdsArr = idsArr;
      this.labelState = true;
      this.addShopBuyerId = val.shopBuyerId;
      this.addBuyerNicks = val.pin;
    },

    // 选择标签返回函数
    transferName4(val) {
      this.labelState = false;
      if (this.labelType == 1 && val.cancel != true) {
        if (this.addResult == true) {
          console.log(1111111);
          // 按查询结果打标签
          this.updateLabelByCondition(val.idArr);
        } else {
          console.log(2222222);
          // 打标签
          this.batchInsertLabel(2, val.idArr);
        }
        return;
      }
      if (this.labelType != 1) {
        this.selectSearchIds = this.selectIdsArr = val.idArr;
        console.log(this.selectIdsArr);
      }
    },

    // 搜索栏-选择标签搜索
    toSearchLabel() {
      this.labelType = -1;
      console.log(this.selectIdsArr);
      // this.selectIdsArr = this.selectIdsArr;
      this.selectIdsArr = this.selectSearchIds;
      this.labelState = true;
      console.log(this.labelState);
    },

    initLevel() {
      // judgeShopBuyerGrade({}).then(res => {
      //   if (res.code != 200) {
      //     //this.isInit=true;
      //     this.formDataList.gradestr = [];
      //     this.$message(res.message);
      //   }
      // });
    },

    cityRadioChange(value) {
      // debugger
      this.formDataList.province = value;
      if (value == "") {
        this.checkedList = [];
        this.cityShow = false;
        // this.selectCityNum = 0;
      } else if (value == "JZH") {
        // this.checkedList = "200000,310000,315000,325000,314000,313000,312000,321000,324000,316000,318000,323000,210000,214000,221000,213000,215000,226000,222000,223001,224000,225000,212000,225300,223800".split(
        //   ","
        // ); //江浙沪地区编码前端写死
        // this.cityShow = false;
        // this.selectCityNum = 0;
      } else if (value == "RemoteArea") {
        // this.checkedList = "830000,834000,838000,839000,848000,843000,844000,845350,841000,831100,833400,835000,832000,843300,844100,831300,810000,810600,812200,811300,813000,814000,815000,817000,650000,653100,655000,657000,661400,663000,666100,671000,673100,674100,674400,675000,677000,678000,678400,850000,852000,854000,856000,857000,859000,860000".split(
        //   ","
        // ); //偏远地区编码前端写死
        // this.selectCityNum = 0;
        // this.cityShow = false;
      } else if (value == "Customized") {
        // this.checkedList = [];
        this.cityShow = true;
        // console.log(this.formDataList.province);
      }
    },
    // 导入会员资料上传前
    beforeAvatarUpload(file) {
      // console.log(file);
      const type = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传头像图片大小不能超过 50MB!");
      }
      return isLt50M && (type === "xls" || type === "xlsx");
    },
    uploadChange(file) {
      this.$refs.uploadMenber.clearFiles();
      this.downloadName = file && file.name;
      this.uploadFile = file && file.raw;
      console.log();
    },
    // 导入会员资料上传成功
    handleAvatarSuccess() {
      let formData = new FormData();
      formData.append("file", this.uploadFile);
      // console.log(this.uploadFile);
      if (this.uploadFile == null) {
        this.$message.warning("您未导入数据");
        this.importMenberData = false;
        return;
      }
      uploadFile(formData).then((res) => {
        if (res && res.code == 1) {
          // console.log(res.data);
          let mes = `导入成功${res.data.successCount}个，失败${res.data.falseCount}个`;
          this.$message.success(mes);
          this.downloadName = null;
          this.importMenberData = false;
          this.getData();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    handleImportMenber() {
      this.downloadName = null;
      this.importMenberData = false;
    },
    // 导入会员资料的下载模板
    downloadTemp() {
      const url = "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/buyer_example.xls";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", "buyer_example.xls");
      document.body.appendChild(elem);
      elem.click();
    },
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.show-box {
  position: relative;
  .hover-show {
    display: none;
    position: absolute;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #fff;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
  }
  &:hover {
    .hover-show {
      display: inline-block;
    }
  }
}

// /deep/.table-box .el-table__body-wrapper {
//   overflow: visible;
// }
// /deep/.el-table__row .cell {
//   overflow: visible !important;
// }
// /deep/.el-button--text {
//   color:#7F85E9 ;
// }

.el-message-box__btns /deep/.el-button--small {
  font-size: 14px;
}
/deep/.my_select_time .time_to_text {
  height: 30px;
}
/deep/ .el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
.titiecolor {
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}
.label-btn {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: #ff948f;
  border: 1px solid #ff948f;
  // height: 16px;
  line-height: 14px;
  margin-right: 20px;
  border-radius: 6px;
  span {
    padding: 0 4px;
  }
  &:hover {
    position: relative;
    color: #fe4d45;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-color: #fe4d45;
    i {
      display: inline-block;
    }
  }
  i {
    width: 16px;
    height: 16px;
    // top: 1px;
    // left: 1px;
    background: #fe4d45;
    vertical-align: top;
    position: relative;
    display: none;
    border-radius: 50%;
  }
  i:before,
  i:after {
    position: absolute;
    content: "";
    width: 1px;
    height: 9px;
    background: #fff;
    left: 8px;
    top: 4px;
  }
  i:before {
    transform: rotate(45deg);
  }
  i:after {
    transform: rotate(-45deg);
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.label-add {
  font-size: 16px;
  vertical-align: text-top;
  cursor: pointer;
}
.goods-button {
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
}
.twoContent-one {
  width: 141px;
  height: 32px;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 32px;
  color: rgba(255, 255, 255, 1);
  float: left;
  cursor: pointer;
}
.twoContent-two {
  float: right;
  width: 139px;
  height: 30px;
  border: 1px solid rgba(102, 102, 102, 0.18823529411764706);
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  cursor: pointer;
}
/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}
.hug-send {
  overflow: hidden;
  margin-top: 20px;
  .send-left {
    float: left;
    height: 20px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }
  .send-right {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 220px;
  }
  .send-right2 {
    height: 32px;
    border-bottom: 2px solid rgba(245, 245, 245, 1);
  }
  .codeBtn {
    border: none;
    width: 110px;
    display: inline-block;
    line-height: 26px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    outline-style: none;
  }
  .getNumber {
    display: inline-block;

    width: 100px;
    border: none;
    background: none;
    outline-style: none;
    color: rgba(153, 153, 153, 1);
    line-height: 26px;
  }
  .msg {
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }
}
.table-data-box {
  margin-top: 20px;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 8px 30px 30px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .button-box {
    margin-bottom: 20px;
    .clearfix {
      clear: both;
    }
    .float-left-button {
      float: left;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        font-size: 14px;
        min-width: 90px;
        text-align: center;
        height: 32px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-right: 8px;
        cursor: pointer;
        .icon_sms {
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-right: 4px;
        }
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          line-height: 32px;
          vertical-align: middle;
        }
      }
    }
    .float-right-button {
      float: right;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        font-size: 14px;
        min-width: 90px;
        text-align: center;
        height: 32px;
        // margin-top: 10px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-right: 8px;
        cursor: pointer;
        .icon_sms {
          width: 12px;
          height: 12px;
          vertical-align: middle;
          margin-right: 4px;
        }
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          line-height: 32px;
          vertical-align: middle;
        }
      }
      // .icon_wrap {
      //   cursor: pointer;
      //   display: inline-block;
      //   border: 1px solid #ddd;
      //   border-radius: 4px;
      //   padding: 6px;
      //   width: 26px;
      //   height: 26px;
      //   box-sizing: border-box;
      //   font-size: 0;
      //   margin-left: 10px;
      //   img {
      //     width: 14px;
      //     height: 14px;
      //   }
      // }
    }
  }
}
.section-right-content-box {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  /*box-shadow: 0 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 16px 16px 27px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  // padding-bottom: 50px;
  .division-line {
    position: absolute;
    top: 54px;
    width: 100%;
    left: 0;
    height: 1px;
    background-color: #f6f6f6;
  }
  .router-title {
    font-size: 16px;
    color: #2e3458;
    margin-bottom: 37px;
    font-weight: bold;
    line-height: 22px;
  }
  .tips-title {
    height: 42px;
    line-height: 42px;
    background-color: rgba(247, 248, 250, 0.7);
    padding-left: 14px;
    margin-bottom: 16px;
    .notice-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8.49px;
    }
    .notice-content {
      display: inline-block;
      vertical-align: middle;
      .black-type {
        display: inline-block;
        vertical-align: middle;
        color: #333333;
        font-size: 14px;
      }
      .highlight-type {
        display: inline-block;
        vertical-align: middle;
        color: #ff7600;
        font-size: 24px;
      }
      .push-in-order-btn {
        display: inline-block;
        vertical-align: middle;
        color: #2062e7;
        font-size: 14px;
        cursor: pointer;
        margin-left: 30px;
      }
    }
  }

  .screen-box {
    .button-status4 {
      padding: 5px 12px;
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      background-color: #f7f8fe;
      border: 1px solid #7f85e9;
      color: #7f85e9;
      &:hover {
        background: rgba(174, 179, 241, 0.16);
        border: 1px solid #7f85e9 !important;
        color: #7f85e9 !important;
      }
      &:active {
        background: rgba(174, 179, 241, 0.24);
        border: 1px solid #7f85e9 !important;
        color: #7f85e9;
      }
    }
    // margin-bottom: 35px;
    .line {
      color: #252c38;
      .to-text {
        display: inline-block;
        vertical-align: middle;
        margin: 0 14px;
      }
      .Customizedbutton {
        height: 32px;
        min-width: 98px;
        padding: 0 10px !important;
        width: auto;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        font-size: 14px;
        border-radius: 3px;
        background-color: #f7f8fe;
        border: 1px solid #7f85e9;
        color: #7f85e9;
        &:hover {
          background: rgba(174, 179, 241, 0.16);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9 !important;
        }
        &:active {
          background: rgba(174, 179, 241, 0.24);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9;
        }
        .item-name {
          display: inline-block;
          vertical-align: middle;
          width: 68px;
        }
        .long-input {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .short-input {
          display: inline-block;
          vertical-align: middle;
          width: 80px;
        }
        .picker {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .checked-box {
          display: inline-block;
          vertical-align: middle;
        }
        .city-input {
          display: inline-block;
          vertical-align: middle;
          width: 246px;
          margin-left: 10px;
        }
      }
      .item {
        display: inline-block;
        vertical-align: middle;
        // margin-right: 3%;
        margin-right: 120px;
        margin-bottom: 14px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .item-name {
          display: inline-block;
          vertical-align: middle;
          width: 68px;
        }
        .long-input {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .short-input {
          display: inline-block;
          vertical-align: middle;
          width: 80px;
        }
        .picker {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .checked-box {
          display: inline-block;
          vertical-align: middle;
        }
        .city-input {
          display: inline-block;
          vertical-align: middle;
          width: 246px;
          margin-left: 10px;
        }
      }
    }
  }

  .button-box {
    margin-bottom: 10px;
    .float-left-button {
      float: left;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        border: 1px solid #2062e7;
        color: #2062e7;
        font-size: 14px;
        min-width: 96px;
        text-align: center;
        height: 32px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-right: 15px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          line-height: 32px;
          vertical-align: middle;
        }
      }

      .button:last-child {
        margin-right: 0;
      }
    }

    .float-right-button {
      float: right;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        min-width: 96px;
        height: 32px;
        line-height: 30px;
        border: 1px solid #2062e7;
        color: #2062e7;
        font-size: 14px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-right: 15px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          vertical-align: middle;
        }
      }
      .button:last-child {
        margin-right: 0;
      }
    }
  }
  .time-screen-box {
    text-align: left;
    margin-bottom: 30px;
    .item-name {
      font-size: 14px;
      display: inline-block;
      vertical-align: middle;
    }
    .item-block {
      display: inline-block;
      vertical-align: middle;
      margin-right: 20px;
    }
  }

  .tabs-box {
    .create-group {
      width: 107px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      font-size: 14px;
      margin-top: 30px;
      .item-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 9px;
      }
      .item-name {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}

.dialog-wrapper {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .dialog-content-hug {
    padding: 0 30px;
    .dialog-content-hug-left {
      float: left;
      text-align: left;
      .item {
        margin-bottom: 15px;
        .item-name {
          display: inline-block;
          vertical-align: middle;
          color: #666666;
          font-size: 14px;
        }

        .black-text {
          font-size: 14px;
          color: #666666;
          display: inline-block;
          vertical-align: middle;
        }

        .highlight-text {
          font-size: 24px;
          color: #ff7600;
          display: inline-block;
          vertical-align: middle;
          padding: 0 7px;
        }

        .button-text {
          font-size: 14px;
          color: #2e72f8;
          display: inline-block;
          vertical-align: middle;
          margin-left: 11px;
          cursor: pointer;
        }

        .input-box {
          display: inline-block;
          vertical-align: middle;
          margin-right: 13px;
        }

        .write-message-box {
          display: inline-block;
          vertical-align: top;
          .message-content-box {
            border: 1px solid rgba(230, 230, 230, 1);
            border-radius: 2px;
            .tabs-head {
              background-color: #f9fafb;
              height: 50px;
              line-height: 50px;
              padding: 0 8px;
              .tabs-button {
                display: inline-block;
                vertical-align: middle;
                padding: 0 13px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #e6e6e6;
                text-align: center;
                background-color: #fff;
                color: #2e72f8;
                margin-right: 9px;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
                cursor: pointer;
              }
            }

            .message-input-box {
              position: relative;
              .back-order-button {
                position: absolute;
                width: 68px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background-color: #f3f3f3;
                bottom: 1px;
                right: 1px;
              }
            }

            .tabs-foot {
              height: 53px;
              line-height: 53px;
              background-color: #f9fafb;
              padding: 0 8px;
              .foot-left {
                float: left;
                span {
                  display: inline-block;
                  vertical-align: middle;
                }

                .ask-content {
                  position: relative;
                  display: inline-block;
                  vertical-align: middle;
                  cursor: pointer;
                  .ask-icon {
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;
                  }

                  .ask-icon-select {
                    position: absolute;
                    bottom: 50px;
                    display: none;
                    width: 375px;
                    height: 80px;
                    line-height: 20px;
                    padding: 20px;
                    background-color: #fff;
                    text-align: left;
                    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
                    color: #999999;
                  }
                }

                .ask-content:hover {
                  .ask-icon-select {
                    display: block;
                  }
                }
              }
              .foot-right {
                float: right;
                height: 30px;
                margin-top: 11px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0 13px;
                background: rgba(46, 114, 248, 0.1);
                border: 1px solid rgba(46, 114, 248, 1);
                border-radius: 2px;
                line-height: 30px;
                text-align: center;
                cursor: pointer;
              }
            }
          }

          .message-tips-box {
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding: 10px;
            background: rgba(255, 118, 0, 0.1);
            border-radius: 3px;
            margin-top: 4px;
          }
        }

        .tool-button {
          display: inline-block;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          vertical-align: middle;
          padding: 8px 15px;
          background: rgba(46, 114, 248, 0.13);
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          border-radius: 3px;
          color: #2e72f8;
          margin-right: 16px;
          cursor: pointer;

          .tool-button-icon {
            display: inline-block;
            vertical-align: middle;
            margin-right: 3px;
          }

          .tool-button-title {
            display: inline-block;
            vertical-align: middle;
          }
        }

        .test-button {
          display: inline-block;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          padding: 6px 27px;
          background: rgba(46, 114, 248, 0.2);
          border-radius: 2px;
          color: #2e72f8;
          cursor: pointer;
        }
      }
    }

    .dialog-content-hug-right {
      float: right;
      .mobile-box {
        position: relative;
        width: 255.75px;
        height: 503.61px;
        background: url("../../assets/images/mobileScreen.png") no-repeat;

        .message-content {
          position: absolute;
          width: 195.33px;
          max-height: 250px;
          padding: 12px 12px;
          border-radius: 6px;
          background-color: #fafafa;
          font-size: 14px;
          line-height: 20px;
          left: 50%;
          margin-left: -104.665px;
          text-align: left;
          top: 25.4%;
        }
      }

      .mobile-tips {
        margin-top: 12px;
        text-align: center;
      }
    }
  }

  .dialog-content-foot {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: rgba(247, 248, 250, 0.7);
    padding: 0 25px;
    text-align: left;
    margin-top: 45px;

    .highlight-text {
      font-size: 25px;
      color: #ff7600;
      font-weight: 500;
    }
  }
}

.add-member-wrapper {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 30px;
  .add-member-content-line {
    margin-bottom: 10px;
    text-align: left;
    .inline-block {
      width: 340px;
      display: inline-block;
      vertical-align: middle;
      .item-name {
        display: inline-block;
        vertical-align: middle;
        width: 100px;
        text-align: right;
        .item-star {
          color: #fa5618;
          font-weight: bold;
        }
      }
      .item-content {
        width: 210px;
        margin-left: 10px;
      }
    }
  }
}

.city-select-wrapper {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  .box-header {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 15px;
    background: rgba(244, 245, 249, 1);
    .box-title {
      font-weight: 600;
      display: inline-block;
      margin-right: 50px;
      font-size: 14px;
    }
  }
  .box-content {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 30px 15px 0 15px;
    .area {
      margin-bottom: 10px;
    }
  }
  .box-footer {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 30px;
    .footer-button {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      width: 100px;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

// 表格-短信内容-多行显示、单行显示
.table-box {
  // margin-top: 20px;

  .table-message {
    cursor: pointer;
  }

  .hoveTitle {
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    white-space: normal;
  }
}

/** 按钮各种状态的改变  */
.button-status1 {
  background-color: #fe4d45;
  font-size: 14px;
  border: 1px solid #fe4d45;
  color: #fff;
}
.button-status1:hover {
  background-color: #fe4d45;
  font-size: 14px;
  opacity: 0.9;
  border: 1px solid #fe4d45;
}
.button-status1:active {
  background-color: #fe4d45;
  border: 1px solid #fe4d45;
}

.button-status2 {
  background-color: #fff;
  border: 1px solid #dddddd;
  font-size: 14px;
  color: #666666;
  &:hover {
    background-color: #fff;
    border: 1px solid #fe4d45;
    background: #fff4f4;
    color: #fe4d45;
  }
  &:active {
    background-color: #fe4d45;
    border: #fe4d45;
    color: #fff;
  }
}

.button-status3 {
  background-color: #fff4f4;
  border: 1px solid #fe4d45;
  font-size: 14px;
  color: #fe4d45;
  &:hover {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff !important;
  }
  &:active {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff;
  }
}
.button-status4 {
  padding: 5px 12px;
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  background-color: #f7f8fe;
  border: 1px solid #7f85e9;
  color: #7f85e9;
  &:hover {
    background: rgba(174, 179, 241, 0.16);
    border: 1px solid #7f85e9 !important;
    color: #7f85e9 !important;
  }
  &:active {
    background: rgba(174, 179, 241, 0.24);
    border: 1px solid #7f85e9 !important;
    color: #7f85e9;
  }
}

.button-status5 {
  background-color: #fff;
  border: 1px solid #fe4d45;
  font-size: 14px;
  color: #fe4d45;
  &:hover {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff;
  }
  &:active {
    background-color: #fe4d45;
    border: #fe4d45;
    color: #fff;
  }
}
@media screen and(max-width: 1380px) {
  .section-right-content-box .screen-box .line .item {
    margin-right: 100px;
  }
}
@media screen and(max-width: 1280px) {
  .section-right-content-box .screen-box .line .item {
    margin-right: 50px;
  }
}
/*** 按钮各种状态的改变 end */

.JoinBackList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  .tipsBox {
    display: flex;
    align-items: center;
    // justify-content: center;
    margin-left: -240px;
    left: 0;
    margin-bottom: 30px;
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    .tips {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
  .btnBox {
    margin-right: -160px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cancelBtn {
      padding: 4px 12px;
      margin-right: 8px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .confirmBtn {
      padding: 5px 12px;
      border: 1px solid rgba(204, 204, 204, 1);
      width: 98px;
      height: 32px;
      color: #fff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
.importMenberData {
  p {
    margin: 20px 0 8px 0;
    color: #333;
    font-size: 14px;
  }
  .import {
    display: flex;
    align-items: center;
    button {
      margin-left: 12px;
    }
  }
  .tips {
    margin: 8px 0 20px 0;
    color: #333;
    font-size: 13px;
    i {
      color: #fe8f8a;
    }
  }
  .btnBox {
    display: flex;
    justify-content: space-between;
    button {
      width: 98px;
      height: 32px;
      line-height: 30px;
      background-color: #fff;
      border: none;
      outline: none;
      cursor: pointer;
      border-radius: 3px;
      font-size: 14px;
      transition: all 0.2s;
    }
    .download {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      border-radius: 3px;
      background-color: #fff4f4;
      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    div {
      display: flex;
      align-items: center;
      .cancelBtn {
        margin-right: 8px;
        width: 98px;
        height: 32px;
        color: #999999;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .confirmBtn {
        width: 98px;
        height: 32px;
        color: #fff;
        border: 1px solid #fe4d45;
        background-color: #fe4d45;
        &:hover {
          background-color: #fe4d45;
          font-size: 14px;
          opacity: 0.9;
          border: 1px solid #fe4d45;
        }
        &:active {
          background-color: #fe4d45;
          font-size: 14px;
          opacity: 0.9;
          border: 1px solid #fe4d45;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.el-popover,
.el-popper {
  padding: 0;
}
.label_search {
  height: 32px;
  // width: 600px;
  position: relative;
}
.label_search .el-select {
  width: 96px;
  height: 32px;
  border-radius: 6px;
}

.label_item {
  width: 72px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(217, 217, 217, 1);
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding: 0px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  margin-right: 8px;
  text-align: center;
}
.more_label {
  max-height: 200px;
  border: 1px solid #999999;
  border-radius: 10px;
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  padding: 5px;
  background: #ffffff;
  z-index: 99;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.label_popover {
  max-height: 300px;
}
.label_list_item {
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(217, 217, 217, 1);
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding: 0px 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  text-align: center;
  line-height: 28px;
  display: block;
  margin-bottom: 8px;
  position: relative;
  cursor: pointer;
  text-align: left;
  width: fit-content;
}
.label_list_item:hover {
  border: 1px solid rgba(224, 32, 32, 1);
  color: rgba(224, 32, 32, 1);
}
.xClass {
  display: none;
  /* display: inline-block; */
  width: 8px;
  position: absolute;
  left: 4px;
  top: -1px;
}
.label_list_item:hover .xClass {
  display: inline-block;
}

/* .popper__arrow{
    position: absolute;
    left: 20px!important;
} */

/* 添加会员弹窗 */
.addMemberDialog .el-input--small .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.addMemberDialog .el-dialog__footer {
  text-align: right;
}

.noPower {
  /* color: #c0c4cc; */
  color: #b4b4b4;
  background: #efefef;
}
/* 选项禁用时 */
.member_list {
  .el-select .el-input.is-disabled .el-input__inner,
  .el-input.is-disabled .el-input__inner,
  .el-input.is-disabled .el-input__icon,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-radio__input.is-disabled + span.el-radio__label {
    // cursor: text;
    cursor: pointer;
  }
}
</style>
<style lang="scss" scoped></style>
